import React, { useState, useEffect } from 'react';
import { Select, Spinner } from '@chakra-ui/react';
import { useSelector, useDispatch } from 'react-redux';
import _ from 'lodash';
import moment from 'moment';

import { TIME_DURATION, OtherData } from '../../config/WordUtil';
import * as actions from '../../redux/actions';
import CardPersonalTaskAnalysis from '../common/Cards/Task/CardPersonalTaskAnalysis';

// Decoration From Department/TaskStatistic.js

export default function PersonalTaskStatistic({ allTask, departmentId }) {
  const [selectedTime, setSelectedTime] = useState(TIME_DURATION.THIS_WEEK);
  const [filteredTask, setFilteredTask] = useState();
  const [filteredTaskOnCommonWork, setFilteredTaskOnCommonWork] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const commonWork = useSelector((state) => state.commonWork);

  useEffect(() => {
    dispatch(actions.commonWorkAllByDepartment(departmentId)).then(() => {
      setIsLoading(true);
    });
    return () => {};
  }, []);

  useEffect(() => {
    let tempFilteredTask;

    if (selectedTime === TIME_DURATION.THIS_DAY) {
      tempFilteredTask = _.filter(allTask, (eachTask) =>
        moment(eachTask.task_issue_date).isSameOrAfter(
          moment().subtract(1, 'days'),
        ),
      );
    } else if (selectedTime === TIME_DURATION.THIS_WEEK) {
      tempFilteredTask = _.filter(allTask, (eachTask) =>
        moment(eachTask.task_issue_date).isSameOrAfter(
          moment().subtract(7, 'days'),
        ),
      );
    } else if (selectedTime === TIME_DURATION.THIS_MONTH) {
      tempFilteredTask = _.filter(allTask, (eachTask) =>
        moment(eachTask.task_issue_date).isSameOrAfter(
          moment().subtract(1, 'months'),
        ),
      );
    } else if (selectedTime === TIME_DURATION.ALL) {
      tempFilteredTask = allTask;
    } else {
      tempFilteredTask = _.filter(allTask, (eachTask) =>
        moment(eachTask.task_issue_date).isSameOrAfter(
          moment().subtract(7, 'days'),
        ),
      );
    }
    setFilteredTask(tempFilteredTask);
    console.log('Filtered Task', tempFilteredTask);

    const tempFilteredTaskOnCommonWork = _.groupBy(
      tempFilteredTask,
      'task_commonwork_id',
    );
    setFilteredTaskOnCommonWork(tempFilteredTaskOnCommonWork);
    console.log('Filtered Task on Common Work', tempFilteredTaskOnCommonWork);
    return () => {};
  }, [selectedTime]);

  if (isLoading)
    return (
      <div>
        <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-xl rounded-lg ">
          <div className="px-\  p-2">
            <div className="m-2 md:w-1/3">
              <p>ช่วงเวลา</p>
              <Select
                placeholder="เลือกช่วงเวลา"
                value={selectedTime}
                onChange={(event) => setSelectedTime(event.target.value)}
              >
                <option value={TIME_DURATION.THIS_DAY}>วันที่ผ่านมา</option>
                <option value={TIME_DURATION.THIS_WEEK}>
                  สัปดาห์ที่ผ่านมา
                </option>
                <option value={TIME_DURATION.THIS_MONTH}>เดือนที่ผ่านมา</option>
                <option value={TIME_DURATION.ALL}>ทั่งหมด</option>
              </Select>
            </div>
          </div>
        </div>

        {_.map(commonWork, (eachCommonWork, index) => {
          if (filteredTaskOnCommonWork[eachCommonWork.work_id]) {
            return (
              <CardPersonalTaskAnalysis
                taskArray={filteredTaskOnCommonWork[eachCommonWork.work_id]}
                commonWorkDatas={eachCommonWork}
                allTaskSize={_.size(filteredTask)}
                key={index}
              />
            );
          } else return <div key={index} />;
        })}
        {filteredTaskOnCommonWork[OtherData.id] && (
          <CardPersonalTaskAnalysis
            commonWorkDatas={null}
            allTaskSize={_.size(filteredTask)}
            taskArray={_.union(
              filteredTaskOnCommonWork[OtherData.id],
              filteredTaskOnCommonWork[null]
                ? filteredTaskOnCommonWork[null]
                : [],
            )}
          />
        )}
      </div>
    );
  else {
    return <Spinner />;
  }
}
